import { render, staticRenderFns } from "./UnReject.vue?vue&type=template&id=33a905a2"
import script from "./UnReject.vue?vue&type=script&lang=js"
export * from "./UnReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports